import { SetIntentRequestPayload, SetIntentResponse } from 'types/api/intent';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

type FetchPostIntentOptions = {
  accessToken: string;
  apikey: string;
  vIntentId: string;
};

export default function fetchDeleteIntent({
  accessToken,
  apikey,
  vIntentId
}: FetchPostIntentOptions): FetchResponse<SetIntentResponse> {
  const body: SetIntentRequestPayload = {
    visaCardsOnly: true
  };

  return fetchReq({
    body,
    headers: {
      access_token: accessToken
    },
    mark: 'delete_intent',
    method: 'DELETE',
    url: `${endpoints.purchaseIntent}/${vIntentId}?apikey=${apikey}`
  });
}
